import ResourceManager from "@/pages/admin/ResourceManager";

export function AdminArtists() {
  return (
    <ResourceManager
      title="Artistes"
      endpoint="artists"
      columns={[{ key: "name", label: "Nom" }, { key: "genre", label: "Genre" }]}
      fields={[
        { name: "name", label: "Nom" },
        { name: "genre", label: "Genre musical" },
        { name: "photo", label: "Photo (URL)", type: "image", full: true },
        { name: "spotify_id", label: "Spotify — ID ou lien artiste (discographie affichée automatiquement)", full: true },
        { name: "bio", label: "Biographie", type: "textarea" },
      ]}
    />
  );
}

export function AdminProjects() {
  return (
    <ResourceManager
      title="Projets"
      endpoint="projects"
      defaultItem={{ type: "Single", status: "Sorti" }}
      columns={[{ key: "title", label: "Titre" }, { key: "artist", label: "Artiste" }, { key: "type", label: "Type" }, { key: "status", label: "Statut" }]}
      fields={[
        { name: "title", label: "Titre" },
        { name: "artist", label: "Artiste" },
        { name: "type", label: "Type", type: "select", options: ["Single", "EP", "Album", "Clip", "Audiovisuel", "Culturel", "Autre"] },
        { name: "status", label: "Statut", placeholder: "ex: Sorti, À venir" },
        { name: "date", label: "Date", placeholder: "AAAA-MM-JJ" },
        { name: "video", label: "Lien vidéo (URL)" },
        { name: "image", label: "Image (URL)", type: "image", full: true },
        { name: "description", label: "Description", type: "textarea" },
      ]}
    />
  );
}

export function AdminNews() {
  return (
    <ResourceManager
      title="Actualités"
      endpoint="news"
      defaultItem={{ status: "BROUILLON", date: new Date().toISOString().split("T")[0] }}
      columns={[{ key: "title", label: "Titre" }, { key: "category", label: "Catégorie" }, { key: "date", label: "Date" }, { key: "status", label: "Statut" }]}
      fields={[
        { name: "title", label: "Titre" },
        { name: "category", label: "Catégorie" },
        { name: "date", label: "Date", placeholder: "AAAA-MM-JJ" },
        { name: "author", label: "Auteur" },
        { name: "status", label: "Statut", type: "select", options: ["BROUILLON", "PUBLIÉ"] },
        { name: "image", label: "Image (URL)", type: "image", full: true },
        { name: "summary", label: "Résumé", type: "textarea", rows: 2 },
        { name: "content", label: "Contenu", type: "textarea", rows: 8 },
      ]}
    />
  );
}

export function AdminCultural() {
  return (
    <ResourceManager
      title="Projets culturels"
      endpoint="cultural"
      defaultItem={{ status: "PUBLIÉ" }}
      columns={[{ key: "title", label: "Titre" }, { key: "type", label: "Type" }]}
      fields={[
        { name: "title", label: "Titre" },
        { name: "type", label: "Type", placeholder: "Atelier, Transmission, Événement…" },
        { name: "date", label: "Date" },
        { name: "image", label: "Image (URL)", type: "image", full: true },
        { name: "description", label: "Description", type: "textarea" },
      ]}
    />
  );
}
